module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Airplay-7100ebb78b17f6dae887ce0b96711471.svg";